import React, { FunctionComponent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { tracker } from '@browsing/tracking';
import { Translate, TranslateScope } from '@pegasus/translation';
import { BrandsS, PriceS, ReturnS } from '@lux/icons';
import { screenSizes } from '@lux/tokens';
import { getClientDeviceWidth } from '@client/redux/modules/clientDevice/selectors';
import { USP_VISIBILITY_START_DATE } from '@client/components/constants';
import { track } from '@client/helpers/tracking';
import { USPSliderWrapper, USPCard, USPCardWrapper } from './usp.styles';
import { HeaderBannerRow } from '../../header/headerWrapper.styles';

export const UspSlider: FunctionComponent<{
    isM1Rebranding: boolean;
    showUSPVisibility: boolean;
}> = ({ isM1Rebranding, showUSPVisibility }) => {
    const [slideAmt, setSlideAmt] = useState(0);
    const deviceWidth = useSelector(getClientDeviceWidth);
    const isMobileView = deviceWidth < screenSizes.sm;

    useEffect(() => {
        if (isM1Rebranding) {
            if (showUSPVisibility) {
                track('campaignoverview_uspbar_seen', {
                    component: 'Campaign Overview',
                });
                tracker.track('GA4-EEC-select_content', {
                    event_name: 'select_content',
                    select_content: {
                        element: 'usp_bar',
                        content_type: 'view',
                        content_id: null,
                    },
                });
            }
            if (!window.localStorage.getItem(USP_VISIBILITY_START_DATE)) {
                window.localStorage.setItem(USP_VISIBILITY_START_DATE, new Date().toDateString());
            }
        }
    }, []);

    useEffect(() => {
        let toTop = 0;
        let timer: ReturnType<typeof setTimeout>;
        const autoPlay = () => {
            timer = setTimeout(function () {
                const row = document.getElementById('usp_slider_wrapper');
                toTop -= 32;
                if (toTop < -64) {
                    toTop = 0;
                    setSlideAmt(0);
                    clearTimeout(timer);
                    if (row) {
                        // @ts-ignore
                        row.onmouseover = clearTimeout(timer);
                    }
                }
                setSlideAmt(toTop);
                autoPlay();
            }, 3000);
        };
        if (isMobileView) {
            autoPlay();
        }

        return () => {
            clearTimeout(timer);
        };
    }, [deviceWidth]);

    return showUSPVisibility && isM1Rebranding ? (
        <TranslateScope path="myLounge.uspRebrand">
            <HeaderBannerRow
                height={32}
                onClick={() => {
                    track('campaignoverview_uspbar_click', {
                        component: 'Campaign Overview',
                    });

                    tracker.track('GA4-EEC-select_content', {
                        event_name: 'select_content',
                        select_content: {
                            element: 'usp_bar',
                            content_type: 'click',
                            content_id: null,
                        },
                    });
                }}
            >
                <USPSliderWrapper>
                    <div className="slider">
                        <USPCardWrapper
                            slideAmt={slideAmt}
                            className="slider__row"
                            id="usp_slider_wrapper"
                        >
                            <USPCard>
                                <BrandsS />
                                <Translate message="brandsYouLove" />
                                <BrandsS className="mobile-extra" />
                            </USPCard>
                            <USPCard>
                                <PriceS />
                                <Translate message="dailyDiscount" />
                                <PriceS className="mobile-extra" />
                            </USPCard>
                            <USPCard>
                                <ReturnS id="delivery" />
                                <Translate message="freeReturns" />
                                <ReturnS className="mobile-extra" id="delivery" />
                            </USPCard>
                        </USPCardWrapper>
                    </div>
                </USPSliderWrapper>
            </HeaderBannerRow>
        </TranslateScope>
    ) : null;
};
